import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import './SiderItem.css';

const SiderItem = ({ item, isActive, withStroke = false }) => {
  const itemClasses = classNames('sider-item', {
    'sider-item-active': isActive,
    'sider-item-stroke': withStroke
  });

  return (
    <Link to={item.path} className={itemClasses}>
      <span className="sider-item-icon">{item.icon}</span>
      <span className="sider-item-label">{item.label}</span>
    </Link>
  );
};

export default SiderItem;
